import {useTranslation} from "react-i18next";
import {Button, Card, Dropdown, Menu} from "antd";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import ReportFilter from "../../app/report/report-grid/ReportFilter";
import ReportGrid from "../../app/report/report-grid/ReportGrid";
import {DATE_OPTIONS, getDateFromNow} from "../../core/utils/date-utils";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import ReportQuickFilterBar from "../../app/report/report-grid/ReportQuickFilterBar";

export default function ReportDataGridPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Reports')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider>
                <LayoutWithSider
                    fullWidth={true}
                    sidebarTitle={t('Report Filter')}
                    rememberOpen={false}
                    sidebarComponent={(
                        <ReportFilter/>
                    )}
                >
                    {/* Hızlı filtreler grid kartının üstünde, her blok ayrı kart; uygulanan filtreyi sol panelle paylaşır.
                        Serbest arama da burada (her ekran boyutunda) — mobildeki ayrı GridSearchBar'ın yerini aldı. */}
                    <ReportQuickFilterBar />
                    <Card>
                        <ReportGrid />
                    </Card>
                </LayoutWithSider>
            </DataGridProvider>
        </>
    )
}
